import { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";
import { useCategory } from "context/CategoryContext";

function CategoriesForm({ setShowForm }) {
  const { storeCategory, updateCategory, editCategory, setEditCategory, loading, setLoading } =
    useCategory();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm();

  const onHandleSubmit = (data) => {
    if (Object.keys(editCategory).length != 0) {
      setShowForm(false);
      setEditCategory({});
      return updateCategory(data);
    }
    setEditCategory({});
    storeCategory(data);
    setShowForm(false);
  };

  const onCancelEditCategory = () => {
    setEditCategory({});
    reset({
      name: "",
    });
  };

  useEffect(() => {
    reset(editCategory);
  }, [editCategory]);

  return (
    <MDBox sx={{ p: 2 }}>
      <Grid
        container
        spacing={2}
        component="form"
        onSubmit={handleSubmit(onHandleSubmit)}
        role="form"
      >
        <Grid item xs={12}>
          <MDInput
            variant="outlined"
            required
            fullWidth
            id="name"
            label="Nome"
            name="name"
            {...register("name")}
            // value={formData.name}
            // onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} spacing={2}>
          {Object.keys(editCategory).length == 0 ? (
            <MDButton
              type="submit"
              disabled={loading}
              fullWidth
              variant="contained"
              color="primary"
            >
              Enviar
            </MDButton>
          ) : (
            <>
              <MDButton type="submit" variant="contained" color="primary">
                Editar
              </MDButton>
              <MDButton variant="contained" color="primary" onClick={onCancelEditCategory}>
                Cancelar
              </MDButton>
            </>
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

CategoriesForm.propTypes = {
  setShowForm: PropTypes.func,
};

export default CategoriesForm;
